export const SECURITY_LEVEL_VALUES = {
  // these values match what's in the db & comes back from the api
  fair: 'fair',
  moderate: 'moderate',
  strong: 'strong',
  veryStrong: 'very_strong',
};

export const SECURITY_LEVEL_LABELS = {
  [SECURITY_LEVEL_VALUES.fair]: 'Fair security',
  [SECURITY_LEVEL_VALUES.moderate]: 'Moderate security',
  [SECURITY_LEVEL_VALUES.strong]: 'Strong security',
  [SECURITY_LEVEL_VALUES.veryStrong]: 'Very strong security',
};

export const DEFAULT_SECURITY_LEVEL = SECURITY_LEVEL_VALUES.fair;
